import type { LocaleMessageSchema } from '../types';

export default {
  Common: {
    loading: 'Φόρτωση...',
  },
  errors: {
    session_create_error:
      'Αποτυχία δημιουργίας συνεδρίας.\nΠαρακαλώ δοκιμάστε ξανά.',
    session_continue_error:
      "Δεν μπορέσαμε να φορτώσουμε τη συνεδρία σας. Παρακαλώ δοκιμάστε ξανά. Αν το πρόβλημα επιμένει, επικοινωνήστε με την υποστήριξη στο service{'@'}theartisan.ai.",
    kiosk_not_found: 'Αποτυχία φόρτωσης kiosk.\nΠαρακαλώ δοκιμάστε ξανά.',

    art_style_missing: 'Δεν έχουν προστεθεί στυλ τέχνης\n σε αυτό το kiosk',
    art_style_fetch_error: 'Αποτυχία φόρτωσης στυλ τέχνης',
    art_style_preload_error: 'Αποτυχία φόρτωσης προεπισκόπησης στυλ τέχνης',

    face_detection_server_error:
      'Αποτυχία επεξεργασίας φωτογραφίας. Παρακαλώ δοκιμάστε ξανά.',
    face_detection_preload_error: 'Σφάλμα προφόρτωσης ανιχνευμένων προσώπων',
    face_detection_no_faces:
      'Δεν εντοπίστηκαν πρόσωπα. Παρακαλώ δοκιμάστε να τραβήξετε άλλη φωτογραφία.',

    photo_webcam_not_allowed: 'Δεν επιτρέπεται η πρόσβαση στην κάμερα',
    photo_webcam_not_found:
      'Δεν βρέθηκε κάμερα. Παρακαλώ ελέγξτε αν είναι συνδεδεμένη στο kiosk.',
    photo_webcam_hardware_error:
      'Η κάμερα είναι απασχολημένη ή δεν λειτουργεί.\nΠαρακαλώ δοκιμάστε ξανά ή ζητήστε βοήθεια.',
    photo_webcam_photo_failed: 'Αποτυχία λήψης φωτογραφίας\n με την κάμερα',

    photo_phone_missing_session_id:
      'Δεν μπορέσαμε να βρούμε τη συνεδρία σας.\nΠαρακαλώ σαρώστε ξανά τον κωδικό QR.',
    photo_phone_missing_kiosk_slug:
      "Δεν βρέθηκε kiosk στη συνεδρία σας. Αν το πρόβλημα επιμένει, επικοινωνήστε με την υποστήριξη στο service{'@'}theartisan.ai.",
    photo_phone_limit_exceeded: 'Υπερβολικός αριθμός επιλεγμένων φωτογραφιών',
    photo_phone_qr_error:
      'Αποτυχία δημιουργίας κωδικού QR\nγια μεταφόρτωση φωτογραφίας',

    photo_file_unsupported_type: 'Μη υποστηριζόμενος τύπος αρχείου',
    photo_file_cannot_process:
      'Δεν είναι δυνατή η επεξεργασία αυτής της φωτογραφίας.\nΠαρακαλώ δοκιμάστε άλλη.',
    photo_file_cannot_process_heic:
      'Δεν είναι δυνατή η επεξεργασία φωτογραφίας HEIC.\nΠαρακαλώ δοκιμάστε άλλη.',

    portrait_generation_error:
      'Παρουσιάστηκε σφάλμα κατά τη δημιουργία του πορτρέτου σας. Παρακαλώ δοκιμάστε ξανά.',
    portrait_generation_faces_not_selected:
      'Δεν επιλέχθηκαν πρόσωπα για\nδημιουργία πορτρέτου',
    portrait_generation_style_not_selected:
      'Δεν επιλέχθηκε στυλ τέχνης για\nδημιουργία πορτρέτου',
    portrait_generation_over_limit: 'Υπερβολικές προσπάθειες δημιουργίας',

    portraits_download_session_error:
      "Δεν μπορέσαμε να βρούμε τη συνεδρία σας. Παρακαλώ ελέγξτε τον κωδικό που εισαγάγατε. Αν το πρόβλημα επιμένει, επικοινωνήστε με την υποστήριξη στο service{'@'}theartisan.ai.",
    portraits_download_kiosk_error:
      "Δεν βρέθηκε kiosk στη συνεδρία σας. Αν το πρόβλημα επιμένει, επικοινωνήστε με την υποστήριξη στο service{'@'}theartisan.ai.",
    portraits_download_portraits_error:
      "Δεν βρέθηκαν πορτρέτα στη συνεδρία σας. Αν το πρόβλημα επιμένει, επικοινωνήστε με την υποστήριξη στο service{'@'}theartisan.ai.",

    payment_partner_mode_missing_stripe_account:
      'Η λειτουργία πληρωμής συνεργάτη απαιτεί λογαριασμό Stripe Connect. Ρυθμίστε τον λογαριασμό Stripe του συνεργάτη ή αλλάξτε σε λειτουργία πληρωμής πλατφόρμας.',

    api_error_missing_session_id: 'Δεν βρέθηκε συνεδρία',
    api_error_email_code_validation:
      'Αποτυχία επικύρωσης κωδικού πληρωμής. Παρακαλώ δοκιμάστε ξανά.',
  },

  /**
   * Global components
   */

  OverlayError: {
    buttons: {
      close: 'Απόρριψη',
      restart: 'Ξεκινήστε Ξανά',
      retry: 'Δοκιμάστε Ξανά',
    },
  },
  Logo: {
    startOver: 'Ξεκινήστε Ξανά',
  },
  Copyright: {
    copyright: 'powered by TheArtisan.ai',
    distribution: 'διανέμεται από',
    terms:
      'Τραβώντας φωτογραφία σε αυτή τη συσκευή, αποδέχεστε τις πολιτικές και τους όρους μας. Για να τους δείτε, παρακαλώ',
    termsLink: 'πατήστε εδώ',
  },
  IdlePopup: {
    title: 'Είστε ακόμα εδώ;',
    caption: 'Η συνεδρία σας θα λήξει αν παραμείνετε ανενεργοί.',
    buttonContinue: 'Ναι, είμαι ακόμα εδώ',
    buttonRestart: 'Όχι, Ξεκινήστε Ξανά',
  },
  GDPRConsent: {
    title: 'Απαιτείται Συγκατάθεση',
    consentText:
      'Χρειαζόμαστε τη συγκατάθεσή σας για να επεξεργαστούμε τα χαρακτηριστικά του προσώπου σας (βιομετρικά δεδομένα) για να δημιουργήσουμε καλλιτεχνικές μετατροπές. Μπορείτε να προχωρήσετε μόνο αν είστε 16 ετών ή άνω (ή έχετε γονική συγκατάθεση).',
    buttonConsent: 'Συγκατατίθεμαι',
    buttonDecline: 'Δεν Συγκατατίθεμαι',
    privacyPolicyLink: 'Προβολή Πολιτικής Απορρήτου',
    declineMessage: 'Δεν μπορείτε να προχωρήσετε χωρίς συγκατάθεση',
  },
  StepProgressIndicator: {
    photoShort: 'Φωτογραφία',
    photoLong: 'Λήψη Φωτογραφίας',
    facesShort: 'Πρόσωπα',
    facesLong: 'Επιλογή Προσώπων',
    groupPortraitsShort: 'Ομάδα',
    groupPortraitsLong: 'Ομαδικά Πορτρέτα',
    portraitsShort: 'Πορτρέτα',
    portraitsLong: 'Επιλογή Πορτρέτων',
    printShort: 'Εκτύπωση',
    printLong: 'Πληρωμή & Εκτύπωση',
    sendToPickupShort: 'Παραλαβή',
    sendToPickupLong: 'Αποστολή στο σημείο παραλαβής',
  },
  UploadedPhotosSidebar: {
    title: 'Οι Φωτογραφίες σας',
    count: '+{extraPhotoCount} ακόμα',
  },
  NumericKeyboard: {
    invalidPin: 'Μη έγκυρος κωδικός PIN',
    clear: 'Καθαρισμός',
    enter: 'Εισαγωγή',
  },
  OutOfService: {
    message:
      'Το συμβόλαιό σας φαίνεται να είναι σε παύση ή έχει λήξει.\nΠαρακαλώ επικοινωνήστε με τον διανομέα σας για υποστήριξη.',
  },

  /**
   * Steps
   */

  Home: {
    title: 'Δημιουργήστε το πορτρέτο σας σε δευτερόλεπτα!',
    button: 'Δοκιμάστε Τώρα!',
  },
  ArtStyle: {
    title: 'Επιλέξτε το Στυλ σας',
  },
  PhotoFromWebcam: {
    titleGetReady: 'Ετοιμαστείτε να τραβήξετε φωτογραφία',
    titleAttention: 'Κοιτάξτε την κάμερα!',
    titleReview: 'Σας αρέσει αυτή η φωτογραφία;',
    titleUpload: 'Μεταφόρτωση της φωτογραφίας σας...',
    buttonPrimaryPhoto: 'Τράβηγμα Φωτογραφίας',
    buttonPrimaryUse: 'Ναι, Χρήση Αυτής της Φωτογραφίας',
    buttonPrimaryRetake: 'Επανάληψη Φωτογραφίας',
    buttonSecondaryUpload: 'Μεταφόρτωση από Τηλέφωνο',
    buttonSecondaryRetake: 'Όχι, Επανάληψη (1 Προσπάθεια Απομένει)',
    buttonSecondaryUseFirst: 'Όχι, Χρήση της Πρώτης Φωτογραφίας',
    titleCameraError: 'Η κάμερα δεν είναι διαθέσιμη',
    buttonRetryCamera: 'Επανάληψη κάμερας',
  },
  PhotoPromptFromPhone: {
    title: 'Μεταφόρτωση Φωτογραφιών από Τηλέφωνο;',
    caption:
      'Εκπλήξτε φίλους και οικογένεια —\nανεβάστε τις φωτογραφίες τους για να δημιουργήσετε πορτρέτα.',
    buttonUpload: 'Ναι, Μεταφόρτωση από Τηλέφωνο',
    buttonSkip: 'Όχι, Παράλειψη Μεταφόρτωσης',
  },
  PhotoFromPhone: {
    title: 'Μεταφορτώστε φωτογραφίες από το τηλέφωνό σας',
    step1: 'Σαρώστε τον κωδικό QR με το τηλέφωνό σας',
    step2: 'Επιλέξτε φωτογραφίες',
    step3: 'Περιμένετε τη μεταφόρτωση',
    waiting: 'Αναμονή για τη μεταφόρτωσή σας...',
    done: 'Επιτυχής μεταφόρτωση',
    buttonCancel: 'Ακύρωση & Επιστροφή',
    buttonSkip: 'Παράλειψη Μεταφόρτωσης',
    buttonContinue: 'Συνέχεια',
    gdprConsentAll:
      'Έχω τη συγκατάθεση όλων στη φωτογραφία για επεξεργασία των χαρακτηριστικών του προσώπου τους',
    gdprOver16: 'Κανείς στη φωτογραφία δεν είναι κάτω των 16 ετών',
    gdprResponsibility: 'Αποδέχομαι πλήρη ευθύνη για συμμόρφωση με το GDPR',
    gdprAgreeToPrefix: 'Συμφωνώ με την',
    gdprPrivacyPolicyLink: 'Πολιτική Απορρήτου',
    gdprAgreeToSuffix: 'όρους για ανεβασμένες φωτογραφίες',
    gdprCheckboxesRequired:
      'Παρακαλώ επιλέξτε όλα τα παρακάτω πλαίσια για να συνεχίσετε',
    buttonSkipKioskPhoto: 'Παράλειψη φωτογραφίας kiosk',
    buttonTakeWebcamPhoto: 'Λήψη φωτογραφίας με webcam',
  },
  FacesIndividual: {
    title: 'Επιλέξτε ποιος θα είναι στα πορτρέτα;',
    buttonConfirm: 'Επιβεβαίωση & Συνέχεια',
    genderMale: 'Άνδρας',
    genderFemale: 'Γυναίκα',
    genderNonBinary: 'Μη-Δυαδικό',
    age0to2: '0-2',
    age3to9: '3-9',
    age10to19: '10-19',
    age20to29: '20-29',
    age30to39: '30-39',
    age40to49: '40-49',
    age50to59: '50-59',
    age60to69: '60-69',
    age70plus: '70+',
    raceWhite: 'Λευκός',
    raceBlack: 'Μαύρος',
    raceEastAsian: 'Ανατολικοασιάτης',
    raceSoutheastAsian: 'Νοτιοανατολικοασιάτης',
    raceIndian: 'Ινδός',
    raceLatino: 'Λατίνος',
    raceMena: 'Μεσανατολίτης',
  },
  Portraits: {
    title: 'Επιλέξτε τα πορτρέτα σας!',
    buttonNext: 'Επόμενο: Εκτύπωση Επιλεγμένων',
    buttonNextGroupOnly: 'Συνέχεια μόνο με Ομαδικά Πορτρέτα',
    galleryScrollBack: 'Προηγούμενα πορτρέτα',
    galleryScrollForward: 'Επόμενα πορτρέτα',
    filterLabel: 'Εμφάνιση',
    filterAll: 'Όλα',
    filterGroup: 'Μαζί',
    filterIndividual: 'Ατομικά',
    stageKindGroup: 'Ομαδικό πορτρέτο',
    stageKindIndividual: 'Πορτρέτο',
    stagePosition: '{index} από {count}',
    stageSelect: 'Επιλογή',
    stageSelected: 'Επιλέχθηκε ✓',
    buttonMore: 'Δημιουργία περισσότερων πορτρέτων ({count} απομένουν)',
    popupTitle: 'Θέλετε να ολοκληρώσετε την παραγγελία σας;',
    popupGroupSelected: 'Ομαδικά πορτρέτα επιλεγμένα: {count} ({price})',
    popupIndividualSelected: 'Ατομικά πορτρέτα επιλεγμένα: {count} ({price})',
    popupTotalSum: 'Συνολικό ποσό: {sum}',
    popupButtonNo: 'Όχι, πίσω',
    popupButtonYes: 'Ναι, εκτύπωση & πληρωμή!',
    error: 'Ωχ! Δεν ήταν δυνατή η δημιουργία αυτού του πορτρέτου.',
    placeholderGenerating: 'Δημιουργία του πορτρέτου σας...',
    placeholderLoading: 'Φόρτωση του πορτρέτου σας...',
    groupPlaceholder: 'Το ομαδικό σας πορτρέτο θα εμφανιστεί εδώ',
    buttonRetry: 'Δοκιμάστε Ξανά',
    buttonErrorDetails: 'Λεπτομέρειες Σφάλματος',
    retrying: 'Επανάληψη...',
    maxRetriesReached: 'Μέγ. επαναλήψεις επιτεύχθηκαν',
    retryAttempts: 'Προσπάθειες: {count}',
    printingLockedPopupTitle:
      'Παρακαλώ καλέστε τον πλησιέστερο υπάλληλο για να εκτυπώσει τα πορτρέτα σας.',
    generationPendingTitle: 'Ορισμένα πορτρέτα δημιουργούνται ακόμα',
    generationPendingCaption:
      'Δημιουργούνται ακόμα {count} πορτρέτα. Θέλετε να περιμένετε για να τα δείτε όλα;',
    generationPendingWait: 'Περιμένετε για όλα',
    generationPendingSendReady: 'Αποστολή {count} έτοιμων πορτρέτων',
    printingLockedPopupCaption:
      'Η εκτύπωση στο kiosk δεν είναι διαθέσιμη όσο δεν είναι παρών κάποιος υπάλληλος.',
  },
  PortraitsGroup: {
    buttonMore: 'Δημιουργία περισσότερων πορτρέτων',
  },
  PrintLock: {
    lockTitle: 'Κλείδωμα εκτύπωσης',
    unlockTitle: 'Ξεκλείδωμα εκτύπωσης',
  },
  PaymentType: {
    title: 'Επιλέξτε τρόπο πληρωμής',
    optionCardTitle: 'Τραπεζική Κάρτα',
    optionCardCaption: 'Visa, Mastercard & 10+ υποστηριζόμενες κάρτες',
    optionVoucherTitle: 'Προπληρωμένα Πορτρέτα',
    optionVoucherCaption:
      'Περιλαμβάνονται στο εισιτήριο — ζητήστε από το προσωπικό',
  },
  PaymentTerminal: {
    title: 'Παρακαλώ ακολουθήστε τις οδηγίες στο τερματικό πληρωμής',
    titlePaymentSuccess: 'Εκτύπωση των πορτρέτων σας...',
    titlePaymentError: 'Αποτυχία πληρωμής',
    titlePrintError1: 'Ορισμένα πορτρέτα απέτυχαν να εκτυπωθούν.',
    titlePrintError2:
      'Παρακαλώ πατήστε "Εκτύπωση Ξανά" παρακάτω για επανάληψη.',
    buttonRetryPrinting: 'Εκτύπωση Ξανά',
    buttonRetry: 'Δοκιμάστε ξανά',
    buttonCancel: 'Ακύρωση',
    buttonExitSession: 'Ξεκινήστε πάλι',
    buttonBack: 'Επιστροφή',
    total: 'Σύνολο:',
    captionPayment: 'Αναμονή πληρωμής σας...',
    captionPrinting: 'Επιτυχής πληρωμή',
    captionPaymentError: 'Κάτι πήγε στραβά. Δοκιμάστε ξανά ή ξεκινήστε πάλι.',
    captionPaymentFinal: 'Η πληρωμή απέτυχε. Ζητήστε βοήθεια από το προσωπικό.',
    failureCaptions: {
      notEnoughFunds:
        'Η κάρτα δεν έχει επαρκές υπόλοιπο. Δοκιμάστε άλλη κάρτα.',
      expiredCard: 'Η κάρτα έχει λήξει. Δοκιμάστε άλλη κάρτα.',
      cardDeclined: 'Η κάρτα απορρίφθηκε. Δοκιμάστε άλλη κάρτα.',
      cardError:
        'Αυτή η κάρτα δεν μπορεί να χρησιμοποιηθεί εδώ. Δοκιμάστε άλλη κάρτα.',
      processingError:
        'Η πληρωμή δεν ολοκληρώθηκε. Δοκιμάστε ξανά με την ίδια κάρτα.',
      readerError:
        'Ο αναγνώστης καρτών δεν είναι διαθέσιμος. Ζητήστε βοήθεια από το προσωπικό.',
      timeout: 'Ο χρόνος για την πληρωμή έληξε. Δοκιμάστε ξανά.',
    },
    errorMessage: 'Δυστυχώς, δεν μπορέσαμε να επεξεργαστούμε την πληρωμή σας',
    popupCancelledTitle: 'Η πληρωμή ακυρώθηκε',
    popupCancelledCaption: 'Θέλετε να δοκιμάσετε ξανά ή να ξεκινήσετε πάλι;',
    popupButtonContinue: 'Δοκιμάστε ξανά',
  },
  PaymentVoucher: {
    title:
      'Παρακαλώ καλέστε έναν υπάλληλο για βοήθεια με την πληρωμή με κουπόνι',
    buttonBack: 'Επιστροφή',
    pinTitle: 'Πληρωμή με κουπόνι',
  },
  Printing: {
    title: 'Εκτύπωση των πορτρέτων σας...',
    titleError: 'Λυπούμαστε, ορισμένα πορτρέτα απέτυχαν να εκτυπωθούν',
    buttonPrintAgain: 'Εκτύπωση Ξανά',
    buttonContinueWithoutPrint: 'Συνέχεια χωρίς εκτύπωση',
    error: 'Ωχ! Δεν ήταν δυνατή η εκτύπωση αυτού του πορτρέτου.',
    errorPartial: 'Εκτυπώθηκαν {printed} από {total}',
    retrying: 'Νέα προσπάθεια…',
    waiting: 'Αναμονή για τον εκτυπωτή…',
  },
  PrintFailed: {
    title: 'Λυπούμαστε, δεν μπορέσαμε να εκτυπώσουμε τις φωτογραφίες σας',
    titlePartial: 'Εκτυπώθηκαν {printed} από {total} φωτογραφίες',
    caption:
      'Μπορείτε να ξεκινήσετε μια νέα συνεδρία και να δημιουργήσετε νέα πορτρέτα.',
    captionRefunded: 'Επιστρέψαμε {amount} στην κάρτα σας.',
    captionNotCharged: 'Δεν σας χρεώσαμε {amount}.',
    captionRefundHelp:
      'Ένας υπάλληλος θα σας βοηθήσει με την επιστροφή χρημάτων.',
  },
  Success: {
    title: 'Ευχαριστούμε!',
    caption: 'Τα έργα σας εκτυπώθηκαν. Παρακαλώ παραλάβετέ τα από τη ρεσεψιόν.',
    buttonStartAgain: 'Ξεκινήστε Ξανά',
  },
  GoPhotoScan: {
    title: 'Σαρώστε το PhotoPass σας',
    subtitle: 'Δείξτε τον κωδικό QR του PhotoPass σας στον σαρωτή',
    invalidCode: 'Μη έγκυρη μορφή κωδικού. Παρακαλώ σαρώστε ξανά.',
    failedToRegister: 'Αποτυχία εγγραφής κωδικού. Παρακαλώ δοκιμάστε ξανά.',
    error: 'Παρουσιάστηκε σφάλμα. Παρακαλώ δοκιμάστε ξανά.',
  },

  /**
   * Customer-facing components
   */

  CustomerPhotoFromPhone: {
    title: 'Μεταφορτώστε φωτογραφίες από τη συλλογή σας',
    buttonSelect: 'Επιλογή Φωτογραφιών',
    maxCount: '{count} φωτογραφίες μέγιστο',
    uploading: 'Μεταφόρτωση...',
    uploadError:
      'Η μεταφόρτωση απέτυχε. Παρακαλώ ελέγξτε τη σύνδεσή σας και δοκιμάστε ξανά.',
    buttonRetry: 'Δοκιμάστε Ξανά',
    successTitle: 'Επιτυχής μεταφόρτωση',
    successCaption:
      'Παρακαλώ επιστρέψτε στο kiosk και ακολουθήστε τις οδηγίες στην οθόνη.',
  },
  CustomerPortraitsDownload: {
    title: 'Εισάγετε Κωδικό για το Πορτρέτο σας',
    buttonSubmit: 'Υποβολή',
    error:
      'Αυτός ο κωδικός δεν φαίνεται σωστός. Ελέγξτε τον κωδικό 8 χαρακτήρων που είναι τυπωμένος στη φωτογραφία σας και δοκιμάστε ξανά.',
    errors: {
      wrongFormat:
        'Αυτός ο κωδικός δεν φαίνεται σωστός. Ελέγξτε τον κωδικό 8 χαρακτήρων που είναι τυπωμένος στη φωτογραφία σας και δοκιμάστε ξανά.',
      notFound:
        'Λυπούμαστε, δεν βρέθηκαν πορτρέτα. Ελέγξτε τον κωδικό — είναι τυπωμένος στο μπροστινό μέρος του πορτρέτου, κάτω αριστερά.',
      serverError:
        'Λυπούμαστε, δεν μπορέσαμε να ανακτήσουμε τα πορτρέτα σας αυτή τη στιγμή. Δοκιμάστε ξανά αργότερα.',
    },
  },
  CustomerSessionPass: {
    tabs: {
      photos: 'Φωτογραφίες',
      pass: 'Πάσο QR',
    },
    eyebrow: 'Το πάσο συνεδρίας σας',
    title: 'Κρατήστε αυτή τη σελίδα ανοιχτή',
    description:
      'Στον σταθμό αγοράς, σαρώστε τον τετράγωνο κωδικό παρακάτω. Τα πορτρέτα σας είναι διαθέσιμα στην καρτέλα «Φωτογραφίες».',
    descriptionNothingPrinted:
      'Στον σταθμό αγοράς, σαρώστε τον τετράγωνο κωδικό παρακάτω για να επιλέξετε και να εκτυπώσετε τις φωτογραφίες σας.',
    scanLabel: 'Σάρωση στον σταθμό αγοράς',
    codeLabel: 'Κωδικός συνεδρίας',
    ready: 'Έτοιμο για σάρωση',
    loading: 'Προετοιμασία κωδικού',
    unavailable: 'Ο κωδικός δεν είναι διαθέσιμος',
    qrAlt: 'Κωδικός QR για τον σταθμό αγοράς',
    defaultVenue: 'Εμπειρία πορτρέτου TheArtisan.ai',
  },
  CustomerPortraitsDownloadCode: {
    error: 'Ωχ! Δεν ήταν δυνατή η φόρτωση αυτού του πορτρέτου.',
    placeholder: 'Φόρτωση του πορτρέτου σας...',
    imageAlt: 'Πορτρέτο',
    buttonDownload: 'Λήψη',
    buttonSendOrShare: 'Αποστολή ή Κοινοποίηση',
    buttonRetry: 'Δοκιμάστε Ξανά',
    shareTitle: 'Το πορτρέτο σας από {clientName}',
    shareText: 'Powered by TheArtisan.ai',
    states: {
      processing:
        'Τα πορτρέτα σας προετοιμάζονται ακόμη. Δοκιμάστε ξανά σε λίγο.',
      partial:
        'Ορισμένα πορτρέτα ή στοιχεία της σελίδας δεν φορτώθηκαν. Οι διαθέσιμες λήψεις εξακολουθούν να λειτουργούν.',
    },
    actions: {
      enterAnotherCode: 'Εισαγωγή άλλου κωδικού',
      contactSupport: 'Επικοινωνία με την υποστήριξη',
      retryDownload: 'Επανάληψη λήψης',
      downloadFailed:
        'Η λήψη απέτυχε. Ελέγξτε τη σύνδεσή σας και δοκιμάστε ξανά.',
      linkCopied:
        'Ο σύνδεσμος αντιγράφηκε. Μπορείτε να τον επικολλήσετε σε μήνυμα.',
      shareFailed:
        'Η κοινοποίηση δεν είναι διαθέσιμη αυτή τη στιγμή. Δοκιμάστε ξανά.',
    },
  },
  CustomerDigitalExtras: {
    downloadTitle: 'Οι φωτογραφίες και το βίντεό σας',
    downloadIntro:
      'Αποθηκεύστε τις φωτογραφίες και το βίντεό σας ή ανοίξτε το εισιτήριο QR.',
    photosTitle: 'Οι φωτογραφίες σας',
    photosIntro: 'Αποθηκεύστε τις φωτογραφίες σας ή ανοίξτε το πάσο QR.',
    navigation: 'Οι λήψεις σας',
    tabs: {
      photos: 'Φωτογραφίες',
      extras: 'Βίντεο',
      pass: 'Εισιτήριο QR',
    },
    title: 'Τα ψηφιακά σας προϊόντα',
    loading: 'Φόρτωση των ψηφιακών σας προϊόντων…',
    loadError:
      'Δεν ήταν δυνατή η φόρτωση των αρχείων σας. Ελέγξτε τη σύνδεσή σας και δοκιμάστε ξανά.',
    included: 'Περιλαμβάνεται',
    includedOrder:
      'Το βίντεό σας περιλαμβάνεται. Κρατήστε το εισιτήριο QR για να το ανοίξετε αργότερα.',
    preparingHelp:
      'Αποθηκεύστε αυτόν τον σύνδεσμο ή κρατήστε το εισιτήριο QR. Μπορείτε να κλείσετε αυτή τη σελίδα και να επιστρέψετε αργότερα.',
    reference: 'Κωδικός αναφοράς: {reference}',
    retry: 'Δοκιμάστε ξανά',
    empty: 'Δεν έχουν προστεθεί ψηφιακά προϊόντα σε αυτή την επίσκεψη.',
    orderTitle: 'Παραγγελία βίντεο',
    showCashier: 'Δείξτε αυτή την παραγγελία και το εισιτήριο QR στο ταμείο.',
    videoTotal: 'Σύνολο βίντεο',
    payAtDesk: 'Η πληρωμή γίνεται στο ταμείο.',
    preparing: 'Προετοιμασία των αρχείων σας…',
    failed:
      'Δεν ήταν δυνατή η δημιουργία του βίντεό σας. Δείξτε τον παρακάτω κωδικό αναφοράς στο προσωπικό του χώρου για βοήθεια.',
    ready: 'Έτοιμο για λήψη',
    video: 'Κινούμενη φωτογραφία',
    videoDescription:
      'Η αγαπημένη σας στιγμή σε κίνηση. Για τα stories σας και για να τη στείλετε στην οικογένεια.',
    download: 'Λήψη',
    share: 'Κοινοποίηση αρχείου',
    preparingShare: 'Προετοιμασία αρχείου…',
    shareFailed:
      'Η κοινοποίηση δεν είναι διαθέσιμη. Πατήστε «Λήψη» για να αποθηκεύσετε το αρχείο.',
  },
  GoPhotoUpload: {
    waitingForPortraits: 'Ολοκλήρωση των πορτρέτων σας',
    waitingForPortraitsSubtitle:
      'Περιμένετε όσο δημιουργούνται τα υπόλοιπα πορτρέτα.',
    success: 'Φωτογραφίες ανέβηκαν!',
    successSubtitle: 'Οι φωτογραφίες σας είναι τώρα διαθέσιμες στο PhotoPass.',
  },
  system: {
    reconnecting: 'Επανασύνδεση με τον διακομιστή…',
  },
} satisfies LocaleMessageSchema;
